import { InventoryLogType } from './inventory-log-type.js';
/** Log types whose `change_qty` moves a reservation rather than on-hand stock. */
export const COMMITMENT_ONLY_LOG_TYPES = [
    InventoryLogType.COMMIT,
    InventoryLogType.UNCOMMIT,
];
//# sourceMappingURL=commitment-only-log-types.js.map